import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
//import { toast } from "react-toastify";
import { useTaxiActions } from "../store/useActions";
import AddressMenuElement from "./AddressMenuElement";
//import {useUISelector} from "../store/useSelectors";

const RedPoint = <div></div>;
const GreyPoint = <div className="grey-color"></div>;
const Slicer = (
  <div className="menu__slicer-wrap">
    <div className="menu__slicer"></div>
  </div>
);

const AddressMenu = (props) => {
  const [results, setResults] = useState([]);
  const [activeField, setActiveField] = useState("start");
  const { setStartAddress, setStartLocation, setEndAddress, setEndLocation } =
    useTaxiActions();


  const { startAddress, endAddress } = useSelector((state) => state.taxi);

  
  const onClickResult = (result) => {
    const lat = parseFloat(result.lat);
    const lon = parseFloat(result.lon);
    if (Number.isNaN(lat) || Number.isNaN(lon)) return;
    const location = { latitude: lat, longitude: lon };
    const name = result.set_name ?? result.address?.residential ?? result.name ?? "";
    if (activeField === "start") {
      setStartAddress(name);
      setStartLocation(location);
    } else {
      setEndAddress(name);
      setEndLocation(location);
    }
    setResults([]);
  };

  return (
    <>
      <AddressMenuElement
        key="1"
        point={RedPoint}
        text={startAddress || ""}
        isInput={props.isInput}
        isStart={true}
        setResults={setResults}
        setActiveField={setActiveField}
        isEntranceRequired={props.isEntranceRequired}
        isManagerOrder={props.isManagerOrder}
      />

      {Slicer}

      <AddressMenuElement
        key="2"
        point={GreyPoint}
        text={endAddress || ""}
        style={{ paddingBottom: "12px" }}
        isInput={props.isInput}
        setResults={setResults}
        setActiveField={setActiveField}
        isManagerOrder={props.isManagerOrder}
      />
      <div
          className="address-results"
          style={results.length === 0 ? { display: "none" } : {}}
      >
        {results.map((result, idx) => {
          const key = result.place_id != null ? String(result.place_id) : `addr-${result.lat}-${result.lon}-${idx}`;
          return (
            <Fragment key={key}>
              <div
                className="address-result"
                onClick={() => onClickResult(result)}
              >
                  <div
                      className="address-result-city"
                  >
                      {result.address?.city ?? ""}
                  </div>
                  <div
                      className="address-result-address"
                  >
                      {result.address?.residential ?? result.display_name ?? ""}
                  </div>
              </div>
              {Slicer}
            </Fragment>
          );
        })}
      </div>
    </>
  );
};

export default AddressMenu;
